import { Directive } from '@angular/core';


@Directive({
    selector: '[mcPrefix]'
})
export class McPrefix {}
